export default __webpack_public_path__ + "static/char-s-47-ja-350856c5695304f33f21e71e3f863bc4.png";